var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('more')}}},[(_vm.loading)?_c('b-spinner',{staticClass:"mr-2",attrs:{"small":""}}):_vm._e(),_c('small',[_vm._v("show more +")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }